import { render, staticRenderFns } from "./WatchExerciseHandoff.vue?vue&type=template&id=d6941c86&scoped=true"
import script from "./WatchExerciseHandoff.vue?vue&type=script&lang=js"
export * from "./WatchExerciseHandoff.vue?vue&type=script&lang=js"
import style0 from "./WatchExerciseHandoff.vue?vue&type=style&index=0&id=d6941c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6941c86",
  null
  
)

export default component.exports